/* eslint-disable no-underscore-dangle */
import {
  ResumeInputCard,
  ResumePictureCard,
  SelectCard,
  Path,
  ButtonNext,
  Select2,
} from 'components/index'
import { Form } from '@unform/web'
import { Icon } from 'assets/index'
import { useStorage, useFetch } from 'hooks'
import { useContext, useEffect, useRef } from 'react'
import { UserContext } from 'context'
import * as Yup from 'yup'
import validate from 'helper/validate.js'
import { Container, Column, Row } from './style'

const levels = [
  ['profile.svg', 'Especialista', `[0, 0, 1, 0, 0, 0, 0, 0, 0]`],
  ['users.svg', 'Gestor e Especia.', `[0, 0,1, 0, 1, 0, 0, 0, 0]`],
  ['users.svg', 'Gestor', '[0, 0, 0, 0, 1, 0, 0, 0, 0]'],
  ['users.svg', 'Diretor', '[0, 0, 0, 1, 0, 0, 0, 0, 0]'],
  ['dollar.svg', 'Financeiro', '[0, 0, 0, 0, 0, 1, 0, 0, 0]'],
  ['dollar.svg', 'Analista de pagamento', '[1, 0, 0, 0, 0, 0, 0, 0, 0]'],
  ['dollar.svg', 'Analista de contrato', '[0, 1, 0, 0, 0, 0, 0, 0, 0]'],
  ['file.svg', 'Jurídico', '[0, 0, 0, 0, 0, 0, 1, 0, 0]'],
  ['volume.svg', 'RI', '[0, 0, 0, 0, 0, 0, 0, 1, 0]'],
  ['settings.svg', 'Gestão usuários', '[0, 0, 0, 0, 0, 0, 0, 0, 1]'],
  ['users.svg', 'Owner', '[1, 1, 1, 1, 1, 1, 1, 1, 1]'],
]

const schemaNewGestor = (isRegisteringPJ: boolean) =>
  Yup.object().shape({
    name: Yup.string().required('campo obrigatório: nome'),
    document: Yup.string()
      .required('Campo obrigatório')
      .test('is-valid-document', 'Documento inválido', (value, context) => {
        if (isRegisteringPJ) {
          // Validar CPF
          if (!validate.numbers.cnpj(value)) {
            return context.createError({ message: 'CNPJ inválido' })
          }
        } else if (!validate.numbers.cnpj(value)) {
          // Validar CNPJ
          return context.createError({ message: 'CPF inválido' })
        }
        return true
      }),
    email: Yup.string().required('campo obrigatório: email'),
    nickname: Yup.string().when([], {
      is: () => isRegisteringPJ,
      then: Yup.string().required('Campo obrigatório'),
      otherwise: Yup.string().notRequired(),
    }),
    cellphone: Yup.string()
      .min(15)
      .max(15)
      .required('campo obrigatório: telefone'),
    level: Yup.string().min(20).max(21).required('campo obrigatório: level'),
    profilePic: Yup.mixed().test('isFile', 'Value must be a file', (value) => {
      return value instanceof File
    }),
  })

export default function ResumoColaborador() {
  const {
    data,
    setData,
    setAllowNextPage,
    requestFn,
    preview,
    feedback,
    setPage,
  } = useContext(UserContext)
  const formData = useRef<FormData>(new FormData())
  const formRef = useRef<HTMLFormElement | any>(null)
  const [gestores] = useStorage('Gestores')
  const api = useFetch()
  feedback.current = { title: 'Colaborador adicionado!', error: false }
  requestFn.current = async () => {
    const formated = { ...data, superiorId: data?.superiorId?.value }
    if (data?.level !== `[1, 0, 0, 0, 0, 0, 0]`) {
      delete formated.superiorId
    }

    try {
      Object.entries(formated).forEach(([key, value]: any) => {
        if (key === 'profilePic') return formData.current.set(key, value)
        if (typeof value === 'object') value = JSON.stringify(value)
        formData.current.set(key, value)
      })
      const r: any = await api.fetch('post', formData.current, `/gestor`, {
        'Content-Type': 'multipart/form-data',
      })
      // console.log('respostaaaaaa', r)
      return r
      // if (r.fail) {
      //   feedback.current = {
      //     title: `${r.errors.message}`,
      //     error: true,
      //   }
      // }
      // if (r.fail) throw new Error(JSON.stringify(r.errors))
    } catch (err: any) {
      console.error(err)
      return err
      // feedback.current = { title: `Erro ${err.message}`, error: true }
    }
  }
  const isRegisteringPJ = Object.keys(data || {}).includes('nickname')

  useEffect(() => {
    setAllowNextPage(false)
    const validateInputs = async () => {
      try {
        await schemaNewGestor(isRegisteringPJ).validate(data, {
          abortEarly: false,
        })
        setAllowNextPage(true)
      } catch (err) {
        console.error(err)
        setAllowNextPage(true)
      }
    }
    validateInputs()
  }, [data])

  return (
    <Container>
      <Path className="path">
        <span className="path">
          {'Gestão de colaboradores > Novo Colaborador'}
        </span>
      </Path>
      <div className="new-colaborator-container">
        <h1 className="new-colaborator-title">Resumo Novo Colaborador</h1>
        <span className="new-colaborator-instruction">
          Confira e avance na seta abaixo para confirmar a criação
        </span>
      </div>
      <div className="new-colaborator-container">
        {isRegisteringPJ && (
          <ResumeInputCard
            icon="profile.svg"
            placeholder={data?.nickname || ''}
            names="nickname"
            data-testid="nickname-input"
            maxLength={64}
            handleChangeInput={(e: any) => {
              setData((oldValue: any) => ({
                ...oldValue,
                nickname: e,
              }))
            }}
          >
            Nome Fantasia
          </ResumeInputCard>
        )}
        <ResumeInputCard
          icon="profile.svg"
          placeholder={data?.name || ''}
          names="name"
          data-testid="name-input"
          maxLength={64}
          handleChangeInput={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              name: e,
            }))
          }}
        >
          {isRegisteringPJ ? 'Razão social' : 'Nome do colaborador'}
        </ResumeInputCard>
        <ResumeInputCard
          icon="profile.svg"
          placeholder={data?.document || ''}
          names="cpf"
          data-testid="cpf-input"
          isMask={isRegisteringPJ ? '00.000.000/0000-00' : '000.000.000-00'}
          handleChangeInput={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              document: e,
            }))
          }}
        >
          {isRegisteringPJ ? 'CNPJ' : '  CPF'}
        </ResumeInputCard>
        <ResumeInputCard
          icon="mail.svg"
          data-testid="email-input"
          maxLength={64}
          placeholder={data?.email || ''}
          names="email"
          handleChangeInput={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              email: e,
            }))
          }}
        >
          Email
        </ResumeInputCard>
        <ResumeInputCard
          icon="profile.svg"
          placeholder={data?.cellphone || ''}
          data-testid="phone-input"
          names="phoneNumber"
          isMask="(00) 00000-0000"
          handleChangeInput={(e: any) => {
            setData((oldValue: any) => ({
              ...oldValue,
              cellphone: e,
            }))
          }}
        >
          Número de celular
        </ResumeInputCard>
        <ResumePictureCard
          name="edit picture"
          data-testid="profile-pic"
          title="Foto"
          img={preview}
        />
      </div>
      {/* Comissionamento
      <div className="new-colaborator-subtitle" style={{ marginBottom: 5 }}>
        <img
          className="iconClickable"
          src={Icon('safety.svg')}
          alt="subtitle img"
        />
        <h4>Comissões</h4>
      </div>
      <div className="new-colaborator-container">
        <Column>
          {data?.comission?.map((item: any) => {
            return (
              <Row data-testid={`row-${item?.label}`}>
                <p className="selected-client-name">{item?.label}</p>
                <button
                  className="trash-btn"
                  disabled={data?.comission?.length === 1}
                  type="button"
                  onClick={() => {
                    setData((oldValue: any) => ({
                      ...oldValue,
                      comission: data?.comission?.filter(
                        (client: any) => client.value !== item.value
                      ),
                    }))
                  }}
                >
                  <img
                    className="cliente-trash"
                    src={Icon('trash.svg')}
                    alt="trash icon"
                  />
                </button>
              </Row>
            )
          })}
        </Column>
      </div>
      */}

      <div className="new-colaborator-subtitle">
        <img
          className="iconClickable"
          src={Icon('safety.svg')}
          alt="subtitle img"
        />
        <h4>Acessos permitidos</h4>
      </div>
      <div className="new-colaborator-container">
        {levels
          .filter((row) => row[2] === data?.level)
          .map((item) => {
            return (
              <SelectCard
                key={item[1]}
                onClick={() => {
                  console.log('select card clicked')
                }}
                icon={item[0]}
                value={item[1]}
                data-testid={`select-card-${item[1]}`}
                checked
              />
            )
          })}
      </div>
      {data?.level === `[0, 0, 1, 0, 0, 0, 0, 0, 0]` && (
        <>
          <div
            className="new-colaborator-subtitle"
            style={{ marginTop: 10, marginBottom: 30 }}
          >
            <img
              className="new-colaborator-subtitle-img"
              src={Icon('trophy.svg')}
              alt="subtitle icon"
            />
            <h4>Time comercial que o especialista estará inserido</h4>
          </div>
          <Form ref={formRef} onSubmit={() => console.log('submit')}>
            <Select2
              dataTestId="gestor-select"
              large
              placeholder="Gestor"
              name="gestor"
              options={gestores}
              onChange={(e: any) => {
                setData((oldValue: any) => ({
                  ...oldValue,
                  superiorId: e,
                }))
              }}
              searchbar={false}
              value={data?.superiorId}
            />
          </Form>
        </>
      )}
      <ButtonNext
        isAdvance
        advancePage={() => setPage((prev) => prev + 1)}
        isBack
        backPage={() => setPage((prev) => prev - 1)}
      />
    </Container>
  )
}
